import { faker } from '@faker-js/faker';
import { cleanup } from '@testing-library/react';
import { HttpResponse, http } from 'msw';
import { setupServer } from 'msw/node';
import { vi } from 'vitest';

import constants from '../constants';
import redux from '../redux';
import translations from '../translations';

translations.init();

describe('customer group selector failure while updating the current context', () => {
  // create a mock server
  const server = setupServer(
    http.put(constants.endpoints.put.context, () => {
      return HttpResponse.json({ status: 500 }, { status: 500 });
    }),
  );

  beforeAll(() => {
    window.location = {
      ...window.location,
      reload: vi.fn(),
    };
    server.listen();
  });

  afterAll(() => {
    server.close();
  });

  afterEach(() => {
    server.resetHandlers();
    cleanup();
  });

  it('should fail to update the current context', async () => {
    redux.store.dispatch(
      redux.api.putContext({
        customer_group_uuid: faker.string.uuid(),
        customer_uuid: faker.string.uuid(),
      }),
    );

    await new Promise((resolve) => {
      setTimeout(resolve, 100);
    });

    expect(redux.store.getState().api.context).toBeNull();
    expect(redux.store.getState().api.isError).toStrictEqual(true);
    expect(window.location.reload).not.toHaveBeenCalled();
  });
});
